/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_TitleInputs */

const vi_tea_purchase_title = /** @type {(inputs: Tea_Purchase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn mua chè từ hộ`)
};

/**

* @param {Tea_Purchase_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_title = /** @type {((inputs?: Tea_Purchase_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_title(inputs)
});